import React, { useMemo, useState, useEffect, useCallback, useReducer } from 'react';

import {
	TranslatedString,
	CommandBar,
	useAjax,
	XhrStatus,
	LoaderIndicator,
	Form,
	SearchField,
	Card,
	PrimaryButton,
	Icon
} from '@bosch/bt-ui';

import './SimDetailPage.css';
import withErrorHandler from '../../components/ErrorHandler';
import SearchBox from '../../components/SearchBox';
import SimDetail from './SimComponent/SimDetail';
import RestfulCallLoading from '../../components/RestfulCallLoading';
import RestfulCallout from '../../components/RestfulCallout';
import SuccessIcon from '../../../icons/alert-success.svg';
import ErrorIcon from '../../../icons/abort-frame.svg';
import DownloadBillingReport from './SimComponent/DownloadBillingReport';
import { prepareLogData } from '../../components/Util';

const SimManagementPage = (props) => {
	const {
		token,
	} = props;
	const [searchSim, setSearchText] = useState('');
	const [errorState, setErrorState] = useState(false);
	const [searchErrorMessage, setSearchErrorMessage] = useState('');
	const [result, status, getSimStatus, response] = useAjax(XhrStatus.Initial);
	const [ returnResult, statusc, runAjaxInner, responsec] = useAjax(XhrStatus.Initial);

	const onFormSubmit = useCallback(
		() => {

			const data = prepareLogData(token,'SIM_Information', 'Compare Button with Sim: ' + searchSim);

			setErrorState(true);
			if (searchSim)
				getSimStatus('GET', SUPPORTCONSOLE_API_URL + '/api/siminformation/v1/simdetail/' + encodeURIComponent(searchSim), null, undefined, { 'Authorization': 'Bearer ' + token.token });
				//Add activity log
				fetch(SUPPORTCONSOLE_API_URL + '/api/activity/v1/activitylog', {
					method: 'POST',
					headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + token.token
					},
					body: JSON.stringify(data)
				})	
		},
		[searchSim, token.token, getSimStatus,runAjaxInner]
	);
	return (
		<Card
			background="secondary"
			htmlAttributes={{
				id: 'sim-management-page',
				className: 'sim-search-input'
			}}>
			<RestfulCallout status={status} response={response} returnObj={result} />
			<div className="form-input">
				<Form
					formAttributes={{
						onSubmit: onFormSubmit,
						method: 'get',
						action: ''
					}}
				>
					<SearchField
						fieldName="search"
						shouldAlwaysShowErrors={errorState}
						validationError={searchErrorMessage}
						onValidationError={(update) => {
							setSearchErrorMessage(update.value);

						}}
						htmlAttributes={{
							onChange: update => setSearchText(update.value),
							value: searchSim,
							placeholder: 'SIM ID',
							required: true
						}}
					/>
					<PrimaryButton type="submit">Compare</PrimaryButton>
				</Form>
			</div>

			<div className="sim-detail-show">
				<SimDetail simDetails={result?.data?.mobileBrokerSimData} deviceProviderName='MobileBroker' />
				{
					result != null ?
						result.status === 'Success' ?
							<Icon icon={SuccessIcon} size={50}
								htmlAttributes={{
									className: 'success-icon'
								}} />
							:
							<Icon icon={ErrorIcon} size={50}
								htmlAttributes={{
									className: 'error-icon'
								}} />
						:
						<div></div>
				}
				<SimDetail simDetails={result?.data?.vendorSimData} deviceProviderName={result?.data?.vendorSimData?.vendorCode} />
			</div>
			<SimDetail simDetails={result?.data?.connectorSimData} deviceProviderName='Connector' />
			<DownloadBillingReport token={token} />
			<RestfulCallLoading status={status} />
		</Card>
	);
};

export default withErrorHandler(React.memo(SimManagementPage));